module.exports = __webpack_public_path__ + "img/map1_empty.ec8addfa.png";